module.exports = __webpack_public_path__ + "img/5g.ea1ba16d.jpg";